// translations/bn.ts
import { TranslationKeys } from '../index';

export const bn: TranslationKeys = {
  header: {
    tutorialButton: "টিউটোরিয়াল",
    currentLanguage: "বর্তমান"
  },
  hero: {
    title: "এখন সুডোকু বনাম খেলুন!",
    description: "একটি অন্যরকম সুডোকু চ্যালেঞ্জের জন্য প্রস্তুত হন! একা অনুশীলন উপভোগ করুন বা বন্ধুদের বিরুদ্ধে মুখোমুখি হন — এখনই ডাউনলোড করুন এবং উত্তেজনা অনুভব করুন!",
    howToPlay: "কিভাবে খেলতে হয়",
    googlePlay: {
      topText: "এখানে পান",
      bottomText: "Google Play"
    },
    appStore: {
      topText: "এখান থেকে ডাউনলোড করুন",
      bottomText: "App Store"
    },
    botButtonShow: "সাহায্য প্রয়োজন? আমাদের বটকে জিজ্ঞাসা করুন!",
    botButtonHide: "সহকারী লুকান"
  },
  footer: {
    followUs: "আমাদের অনুসরণ করুন",
    handle: "@SUDOKU.VS",
    copyright: "© 2024 সুডোকু বনাম। সর্বস্বত্ব সংরক্ষিত।"
  },
  beginnersGuide: {
    modalTitle: "নতুনদের জন্য গাইড",
    originsTab: "সুডোকুর উৎপত্তি",
    basicsTab: "সুডোকুর মূল বিষয়",
    rulesTab: "বনাম খেলার নিয়ম",
    origins: {
      bulletOne: "ল্যাটিন স্কয়ার দ্বারা অনুপ্রাণিত; প্রথম 1979 সালে হাওয়ার্ড গার্নস দ্বারা প্রকাশিত।",
      bulletTwo: "1980-এর দশকে জাপানে জনপ্রিয় হয়ে ওঠে, নাম পরিবর্তন করে 'সুডোকু' রাখা হয়। 2000-এর দশকে বিশ্বব্যাপী খ্যাতি অর্জন করে।",
      bulletThree: "নয়টি 3x3 সাবগ্রিড সহ 9x9 গ্রিড; সারি, কলাম বা সাবগ্রিডে পুনরাবৃত্তি ছাড়াই 1 থেকে 9 দিয়ে পূরণ করুন।",
      bulletFour: "লক্ষ লক্ষ মানুষের প্রিয়, অনেক বৈচিত্র্য এবং নতুন চ্যালেঞ্জ সহ।",
      gridSize: {
        four: "4 X 4",
        six: "6 X 6",
        nine: "9 X 9",
      }
    },
    basics: {
      fillMissing: "অনুপস্থিত সংখ্যাটি পূরণ করুন!",
      correct: "সঠিক!",
      incorrect: "ভুল",
      instructions: "হাইলাইট করা স্থানের জন্য সঠিক সংখ্যা প্রবেশ করে 3X3 ধাঁধাটি সম্পূর্ণ করুন। প্রতিটি সারি, কলাম এবং বাক্সে প্রতিটি সংখ্যা ঠিক একবার থাকতে হবে। সঠিক সংখ্যা নির্বাচন করুন। বিজ্ঞতার সাথে চয়ন করুন!",
      feedbackCorrect: "আপনি আপনার প্রথম বাক্স সমাধান করেছেন!",
      feedbackIncorrect: "আবার চেষ্টা করুন!",
      basicsStep2: {
        instructions: "হাইলাইট করা স্থানের জন্য সঠিক সংখ্যা নির্বাচন করে 4X4 ধাঁধাটি সম্পূর্ণ করুন। প্রতিটি সারি, কলাম এবং বাক্সে প্রতিটি সংখ্যা ঠিক একবার থাকতে হবে। সঠিক সংখ্যা নির্বাচন করুন। বিজ্ঞতার সাথে চয়ন করুন!",
        feedbackCorrect: "আপনি দুর্দান্ত করছেন!"
      },
      basicsStep3: {
        instructions: "হাইলাইট করা স্থানের জন্য সঠিক সংখ্যা নির্বাচন করে 4X4 ধাঁধাটি সম্পূর্ণ করুন। প্রতিটি সারি, কলাম এবং বাক্সে প্রতিটি সংখ্যা ঠিক একবার থাকতে হবে। সঠিক সংখ্যা নির্বাচন করুন। বিজ্ঞতার সাথে চয়ন করুন!",
        feedbackCorrect: "নিখুঁত সমাধান!",
        feedbackIncorrect: "ভুল - আবার চেষ্টা করুন!"
      },
      congratulations: {
        title: "অভিনন্দন!",
        subtitle: "আপনি সফলভাবে সুডোকুর মূল বিষয় টিউটোরিয়াল সম্পন্ন করেছেন! আপনার উত্সর্গ এবং প্রচেষ্টা ফল দিয়েছে, এবং আপনি এখন আত্মবিশ্বাসের সাথে সুডোকু ধাঁধা মোকাবেলা করার জন্য প্রয়োজনীয় দক্ষতার সাথে সজ্জিত।",
        nextStepsTitle: "পরবর্তী পদক্ষেপ",
        nextStepsText: "এখন আপনার দক্ষতা পরীক্ষা করার সময়! আজই সুডোকু গেমটি ডাউনলোড করুন এবং বিভিন্ন ধরণের ধাঁধায় নিজেকে নিমজ্জিত করুন। আপনি একটি দ্রুত একক খেলা পছন্দ করুন বা কিছু বন্ধুত্বপূর্ণ প্রতিযোগিতায় অংশ নিতে চান, আপনি একক মোডে বা একজন প্রতিপক্ষের বিরুদ্ধে বনাম মোডে খেলতে পারেন।",
        ctaHeader: "একটি খেলার জন্য প্রস্তুত?",
        ctaHighlight: "এখনই ডাউনলোড করুন!",
        rulesTitle: "খেলার নিয়মগুলি আয়ত্ত করুন",
        rulesText: "খেলায় নামার আগে, সুডোকু বনাম: খেলার নিয়মগুলি দেখে নিন। নিয়ম এবং পয়েন্ট সিস্টেম বোঝা আপনাকে প্রতিপক্ষের বিরুদ্ধে খেলার সময় একটি সুবিধা দিতে পারে। এই জ্ঞান আপনার অভিজ্ঞতা বাড়াবে এবং আপনাকে কার্যকরভাবে কৌশল করতে সাহায্য করবে!"
      }
    },
    gameRules: {
      notification: {
        important: "গুরুত্বপূর্ণ: ",
        text: "সেরা অভিজ্ঞতার জন্য বিজ্ঞপ্তি সক্ষম করুন!"
      },
      rulesHeader: "নিয়ম",
      rulesList: {
        rule1_pre: "একটি ",
        rule1_strong: "বন্ধুত্বপূর্ণ বা এলোমেলো ম্যাচ",
        rule1_post: " আমন্ত্রণ গ্রহণ করুন বা তৈরি করুন।",
        rule2_pre: "খেলোয়াড়কে ",
        rule2_strong: "প্রথমে যাওয়ার জন্য এলোমেলোভাবে নির্বাচিত করা হয়।",
        rule3: "বোর্ড সম্পূর্ণ না হওয়া পর্যন্ত খেলোয়াড়রা পালা করে খেলে।",
        rule4_pre1: "প্রতিটি ",
        rule4_strong1: "পালা 60 সেকেন্ড স্থায়ী হয়,",
        rule4_pre2: " প্রতি পালায় ",
        rule4_strong2: "5টি সংখ্যার সীমা সহ।",
        rule5_pre: "প্রতি পালায় কেবল ",
        rule5_strong: "1টি ইঙ্গিত",
        rule5_post: " অনুমোদিত।",
        rule6_pre: "সর্বোচ্চ ",
        rule6_strong: "স্কোর সহ খেলোয়াড়",
        rule6_post: " খেলাটি জিতে।",
        rule7_pre: "একটি ",
        rule7_strong_pre: "ড্র",
        rule7_pre2: " এর ক্ষেত্রে, বেশি ইনপুট সহ খেলোয়াড় ",
        rule7_strong_post: "খেলাটি",
        rule7_post: " জিতে।",
        rule8: "আপনি যদি 24 ঘন্টার মধ্যে আপনার পালা শেষ না করেন তবে আপনি স্বয়ংক্রিয়ভাবে খেলাটি হেরে যাবেন।"
      },
      rulesWarning: "24 ঘন্টার মধ্যে আপনার পালা খেলুন নতুবা আপনি স্বয়ংক্রিয়ভাবে খেলাটি হেরে যাবেন",
      gameControls: {
        header: "খেলার নিয়ন্ত্রণ",
        list: {
          control1_pre: "খেলাটি ছেড়ে দেওয়ার জন্য ",
          control1_strong: "আত্মসমর্পণ পতাকা",
          control1_post: " ব্যবহার করুন।",
          control2_pre: "একটি ভুল সংশোধন করতে ",
          control2_strong: "ইরেজার",
          control2_post: " ব্যবহার করুন।",
          control3_pre: "টাইমার শেষ হওয়ার আগে আপনি যদি আপনার সমস্ত ইনপুট সম্পন্ন করে থাকেন তবে ",
          control3_strong: "পালা শেষ করুন",
          control3_post: " ব্যবহার করুন।"
        }
      },
      scoring: {
        header: "স্কোরিং",
        list: {
          score1_pre1: "সঠিক সংখ্যা স্থাপনের জন্য ",
          score1_strong1: "1 পয়েন্ট",
          score1_pre2: " অর্জন করুন।",
          score1_span: "সঠিক",
          score1_post: "",
          score2_pre1: "প্রতিটি ভুল সংখ্যা স্থাপনের জন্য ",
          score2_strong1: "1 পয়েন্ট",
          score2_pre2: " হারান।",
          score2_span: "ভুল",
          score2_post: "",
          score3_pre1: "প্রতিটি সমাধান করা সারি, কলাম এবং বাক্সের জন্য ",
          score3_strong1: "5 পয়েন্ট",
          score3_pre2: " অর্জন করুন।",
          score3_span: "সমাধান করা",
          score3_post: ""
        }
      },
    },
    controller: {
      previous: "পূর্ববর্তী",
      of: " এর ",
      close: "বন্ধ করুন",
      next: "পরবর্তী",
      gameRules: "খেলার নিয়ম",
    },
  },
  tutorials: {
    modalTitle: "টিউটোরিয়াল",
    tabs: {
      introduction: "ভূমিকা",
      gettingStarted: "শুরু করা",
      vsFriends: "বন্ধুদের বিরুদ্ধে",
      howToPlay: "কিভাবে খেলতে হয়",
    },
    messages: {
      loading: "টিউটোরিয়াল লোড হচ্ছে...",
      error: "টিউটোরিয়াল লোড করতে ত্রুটি:",
      fallback: "ফলব্যাক ডেটা ব্যবহার করা হচ্ছে...",
      empty: "এই বিভাগের জন্য কোনো টিউটোরিয়াল উপলব্ধ নেই।",
    },
  },
  cookieConsent: {
    title: "সম্মতি পছন্দগুলি পরিচালনা করুন",
    description: "আমরা আপনার সুডোকু বনাম অভিজ্ঞতা উন্নত করতে, আমাদের ট্র্যাফিক বিশ্লেষণ করতে এবং ব্যক্তিগতকৃত বিজ্ঞাপন সরবরাহ করতে কুকি ব্যবহার করি।",
    acceptAll: "সমস্ত কুকি গ্রহণ করুন",
    confirmChoices: "পছন্দগুলি নিশ্চিত করুন",
    performance: {
      title: "পারফরম্যান্স কুকিজ",
      description: "ব্যবহারের বিশ্লেষণের মাধ্যমে আমাদের খেলা এবং পরিষেবাগুলি উন্নত করার জন্য ডেটা সংগ্রহ করার অনুমতি দেয়।"
    },
    advertising: {
      title: "বিজ্ঞাপন",
      adStorage: "আপনার ডিভাইসে বিজ্ঞাপন ডেটা সংরক্ষণের অনুমতি দেয়",
      adMeasurement: "বিজ্ঞাপন পরিমাপের জন্য ডেটা সংগ্রহের অনুমতি দেয়",
      adPersonalization: "আমাদের আপনার আগ্রহের উপর ভিত্তি করে আপনাকে ব্যক্তিগতকৃত বিজ্ঞাপন দেখানোর অনুমতি দেয়"
    },
    landing: {
        title: "কুকি বিজ্ঞপ্তি",
        description: "আমরা আপনার সুডোকু বনাম অভিজ্ঞতা উন্নত করতে, আমাদের ট্র্যাফিক বিশ্লেষণ করতে এবং ব্যক্তিগতকৃত বিজ্ঞাপন সরবরাহ করতে কুকি ব্যবহার করি। চালিয়ে যাওয়ার আগে আপনি কোন কুকিগুলিকে অনুমতি দিতে চান তা সেট করতে পারেন।",
        acceptAll: "সমস্ত কুকি গ্রহণ করুন",
        customizeSettings: "সেটিংস কাস্টমাইজ করুন",
        fineprint: "\"সমস্ত কুকি গ্রহণ করুন\" এ ক্লিক করে, আপনি সম্মত হন যে<br />সুডোকু বনাম আপনার ডিভাইসে কুকি সংরক্ষণ করতে পারে"
    }
  },

    privacyPolicy: {
    modalTitle: "গোপনীয়তা নীতি",
    sections: {
      introduction: {
        title: "১. ভূমিকা",
        p1: "সুডোকু বনামে স্বাগতম। আমরা আপনার গোপনীয়তা রক্ষা করতে এবং আমাদের ওয়েবসাইটে আপনার একটি ইতিবাচক অভিজ্ঞতা নিশ্চিত করতে প্রতিশ্রুতিবদ্ধ। এই গোপনীয়তা নীতি ব্যাখ্যা করে যে আমরা কীভাবে আপনার সুডোকু গেম প্ল্যাটফর্ম ব্যবহার করার সময় আপনার তথ্য সংগ্রহ, ব্যবহার এবং সুরক্ষা করি।",
        p2: "সুডোকু বনাম ব্যবহার করে, আপনি এই নীতির সাথে সামঞ্জস্যপূর্ণ তথ্য সংগ্রহ ও ব্যবহারে সম্মত হন।"
      },
      informationWeCollect: {
        title: "২. আমরা যে তথ্য সংগ্রহ করি",
        p1: "আমরা আমাদের পরিষেবাগুলি প্রদান এবং উন্নত করতে বিভিন্ন ধরনের তথ্য সংগ্রহ করি:",
        list: {
          usageData: "ব্যবহারের তথ্য: আমরা স্বয়ংক্রিয়ভাবে আপনার গেমের সাথে কীভাবে ইন্টারঅ্যাক্ট করেন সে সম্পর্কে তথ্য সংগ্রহ করি, যার মধ্যে গেমপ্লে পরিসংখ্যান, পাজল সম্পূর্ণ করার সময়, খেলা কঠোরতার স্তর এবং গেম পছন্দ অন্তর্ভুক্ত।",
          deviceInfo: "ডিভাইস তথ্য: আমরা আপনার সুডোকু বনাম অ্যাক্সেস করতে ব্যবহৃত ডিভাইস সম্পর্কে তথ্য সংগ্রহ করতে পারি, যার মধ্যে ডিভাইসের ধরন, ব্রাউজারের ধরন, আইপি ঠিকানা এবং অপারেটিং সিস্টেম অন্তর্ভুক্ত।",
          cookies: "কুকিজ এবং ট্র্যাকিং ডেটা: আমরা আপনার অভিজ্ঞতা উন্নত করতে এবং বিশ্লেষণাত্মক ডেটা সংগ্রহ করতে কুকিজ এবং অনুরূপ ট্র্যাকিং প্রযুক্তি ব্যবহার করি।"
        }
      },
      howWeUseInfo: {
        title: "৩. আমরা আপনার তথ্য কীভাবে ব্যবহার করি",
        p1: "আমরা নিম্নলিখিত উদ্দেশ্যে সংগৃহীত তথ্য ব্যবহার করি:",
        list: {
          gameImprovement: "গেম উন্নতি: গেমপ্লে প্যাটার্ন বিশ্লেষণ করতে এবং আমাদের সুডোকু পাজল, কঠোরতা অ্যালগরিদম এবং সামগ্রিক ব্যবহারকারীর অভিজ্ঞতা উন্নত করতে।",
          performanceAnalytics: "পারফরম্যান্স বিশ্লেষণ: ব্যবহারের প্রবণতা নিরীক্ষণ এবং বিশ্লেষণ করতে, আমাদের পরিষেবার কার্যকারিতা পরিমাপ করতে এবং উন্নতির ক্ষেত্রগুলি চিহ্নিত করতে।",
          personalization: "ব্যক্তিগতকরণ: আপনার গেমিং পছন্দের ভিত্তিতে আপনাকে ব্যক্তিগতকৃত গেম সুপারিশ এবং উপযুক্ত সামগ্রী প্রদান করতে।",
          technicalSupport: "প্রযুক্তিগত সহায়তা: সমস্যা সমাধান করতে, বাগ ঠিক করতে এবং আমাদের প্ল্যাটফর্মের মসৃণ অপারেশন নিশ্চিত করতে।"
        }
      },
      cookies: {
        title: "৪. কুকিজ এবং ট্র্যাকিং প্রযুক্তি",
        p1: "সুডোকু বনাম আপনার অভিজ্ঞতা উন্নত করতে কুকিজ ব্যবহার করে। আপনার কুকি পছন্দ পরিচালনা করার বিকল্প রয়েছে:",
        performanceCookies: {
          title: "পারফরম্যান্স কুকিজ:",
          description: "এই কুকিজগুলি আমাদের ব্যবহারের বিশ্লেষণের মাধ্যমে আমাদের গেম এবং পরিষেবাগুলি উন্নত করার জন্য ডেটা সংগ্রহ করতে দেয়। তারা আমাদের বুঝতে সাহায্য করে যে খেলোয়াড়রা কীভাবে আমাদের পাজলগুলির সাথে ইন্টারঅ্যাক্ট করে, কোন বৈশিষ্ট্যগুলি সবচেয়ে জনপ্রিয় এবং আমরা কোথায় উন্নতি করতে পারি। গেমপ্লে উন্নত করতে এবং আরও ভাল সুডোকু অভিজ্ঞতা তৈরি করতে এই ডেটা অপরিহার্য।"
        },
        advertisingCookies: {
          title: "বিজ্ঞাপন কুকিজ:",
          list: [
            "আপনার ডিভাইসে বিজ্ঞাপন ডেটা সংরক্ষণের অনুমতি দেয়",
            "বিজ্ঞাপন পরিমাপ এবং কার্যকারিতার জন্য ডেটা সংগ্রহ সক্ষম করে",
            "আমাদের আপনার আগ্রহ এবং গেমিং আচরণের ভিত্তিতে আপনাকে ব্যক্তিগতকৃত বিজ্ঞাপন দেখানোর অনুমতি দেয়"
          ]
        },
        p2: "আপনি প্রথমবার আমাদের ওয়েবসাইট পরিদর্শন করার সময় প্রদর্শিত কুকি সম্মতি ব্যানারের মাধ্যমে আপনার কুকি পছন্দগুলি নিয়ন্ত্রণ করতে পারেন। আপনি আপনার ব্রাউজার সেটিংসের মাধ্যমে যেকোনো সময় আপনার সেটিংস পরিবর্তন করতে পারেন, যদিও নির্দিষ্ট কুকিজ নিষ্ক্রিয় করলে ওয়েবসাইটের কার্যকারিতা প্রভাবিত হতে পারে।"
      },
      thirdParty: {
        title: "৫. তৃতীয় পক্ষের পরিষেবা",
        p1: "সুডোকু বনাম নিম্নলিখিত তৃতীয় পক্ষের পরিষেবাগুলির সাথে একীভূত হয়:",
        gemini: {
          title: "গুগল জেমিনি এআই সহকারী:",
          description: "আমাদের সাহায্য বটটি গুগল জেমিনি দ্বারা চালিত হয় একটি অন্তর্নির্মিত জ্ঞান ভিত্তির সাথে যা আপনাকে গেম-সম্পর্কিত প্রশ্নে সহায়তা করতে, সুডোকু টিপস প্রদান করতে এবং সমস্যা সমাধানে সহায়তা করতে। আপনি যখন বটের সাথে ইন্টারঅ্যাক্ট করেন, আপনার প্রশ্নগুলি গুগলের সিস্টেম দ্বারা প্রক্রিয়া করা হতে পারে। তারা কীভাবে ডেটা পরিচালনা করে তার তথ্যের জন্য দয়া করে গুগলের গোপনীয়তা নীতি দেখুন।"
        },
        youtube: {
          title: "ইউটিউব এমবেডেড ভিডিও:",
          description: "আমরা টিউটোরিয়াল সামগ্রী এবং গেমপ্লে গাইড সরাসরি আমাদের ওয়েবসাইটের মধ্যে প্রদান করতে ইউটিউব ভিডিও ওভারলে ব্যবহার করি। আপনি যখন এই ভিডিওগুলির সাথে ইন্টারঅ্যাক্ট করেন, ইউটিউব তাদের গোপনীয়তা নীতি অনুসারে ডেটা সংগ্রহ করতে পারে। আপনি সুডোকু বনাম ছাড়াই ভিডিও দেখতে পারেন, তবে ইউটিউবের ট্র্যাকিং মেকানিজম এখনও প্রযোজ্য হতে পারে।"
        },
        advertising: {
          title: "বিজ্ঞাপন অংশীদার:",
          description: "আমরা আমাদের প্ল্যাটফর্মে বিজ্ঞাপন প্রদর্শন করতে তৃতীয় পক্ষের বিজ্ঞাপন অংশীদারদের সাথে কাজ করি। এই অংশীদাররা ব্যক্তিগতকৃত বিজ্ঞাপনের উদ্দেশ্যে আপনার ব্রাউজিং কার্যকলাপ সম্পর্কে তথ্য সংগ্রহ করতে কুকিজ এবং অনুরূপ প্রযুক্তি ব্যবহার করতে পারে।"
        }
      },
      dataSecurity: {
        title: "৬. ডেটা সুরক্ষা",
        p1: "আমরা আপনার ডেটার সুরক্ষাকে গুরুত্বের সাথে নিই এবং অননুমোদিত অ্যাক্সেস, পরিবর্তন, প্রকাশ বা ধ্বংস থেকে আপনার তথ্য রক্ষা করার জন্য উপযুক্ত প্রযুক্তিগত এবং সাংগঠনিক ব্যবস্থা বাস্তবায়ন করি। যাইহোক, দয়া করে মনে রাখবেন যে ইন্টারনেটের মাধ্যমে ট্রান্সমিশন বা ইলেকট্রনিক স্টোরেজের কোনও পদ্ধতি 100% নিরাপদ নয়।",
        p2: "আমাদের ওয়েবসাইট শিল্প-মান নিরাপত্তা প্রোটোকল ব্যবহার করে এবং একটি নিরাপদ ব্রাউজিং অভিজ্ঞতা নিশ্চিত করতে গোড্যাডি সুরক্ষা সীল দ্বারা যাচাইকৃত।"
      },
      privacyRights: {
        title: "৭. আপনার গোপনীয়তা অধিকার",
        p1: "আপনার ব্যক্তিগত তথ্য সম্পর্কে আপনার নির্দিষ্ট অধিকার রয়েছে:",
        list: {
          access: "অ্যাক্সেস: আপনি আমাদের কাছে আপনার সম্পর্কে রাখা ডেটা সম্পর্কে তথ্য অনুরোধ করতে পারেন",
          correction: "সংশোধন: আপনি ভুল তথ্য সংশোধন করতে অনুরোধ করতে পারেন",
          deletion: "মুছে ফেলা: আপনি আইনি বাধ্যবাধকতার সাপেক্ষে আপনার ডেটা মুছে ফেলার অনুরোধ করতে পারেন",
          optOut: "অপ্ট-আউট: আপনি আপনার কুকি পছন্দের মাধ্যমে ব্যক্তিগতকৃত বিজ্ঞাপন থেকে অপ্ট আউট করতে পারেন",
          portability: "ডেটা বহনযোগ্যতা: আপনি একটি বহনযোগ্য ফর্ম্যাটে আপনার ডেটার একটি কপি অনুরোধ করতে পারেন"
        }
      },
      childrenPrivacy: {
        title: "৮. শিশুদের গোপনীয়তা",
        p1: "সুডোকু বনাম সাধারণ দর্শকদের জন্য ডিজাইন করা হয়েছে। আমরা জেনে শুনে 13 বছরের কম বয়সী শিশুদের কাছ থেকে ব্যক্তিগত তথ্য সংগ্রহ করি না। আপনি যদি পিতামাতা বা অভিভাবক হন এবং বিশ্বাস করেন যে আপনার সন্তান আমাদের ব্যক্তিগত তথ্য প্রদান করেছে, দয়া করে আমাদের সাথে যোগাযোগ করুন যাতে আমরা উপযুক্ত ব্যবস্থা নিতে পারি।"
      },
      changes: {
        title: "৯. এই গোপনীয়তা নীতিতে পরিবর্তন",
        p1: "আমরা আমাদের অনুশীলনে পরিবর্তন বা আইনি, কার্যকরী বা নিয়ন্ত্রক কারণে সময়ে সময়ে এই গোপনীয়তা নীতি আপডেট করতে পারি। আমরা এই পৃষ্ঠায় নতুন গোপনীয়তা নীতি পোস্ট করে এবং নীচের \"সর্বশেষ আপডেট\" তারিখ আপডেট করে আপনাকে যে কোনও গুরুত্বপূর্ণ পরিবর্তন সম্পর্কে অবহিত করব।",
        p2: "আমরা কীভাবে আপনার তথ্য রক্ষা করি সে সম্পর্কে অবগত থাকতে আমরা আপনাকে পর্যায়ক্রমে এই গোপনীয়তা নীতিটি পর্যালোচনা করতে উত্সাহিত করি।"
      },
      contact: {
        title: "১০. আমাদের সাথে যোগাযোগ করুন",
        p1: "এই গোপনীয়তা নীতি বা আমাদের ডেটা অনুশীলন সম্পর্কে আপনার কোন প্রশ্ন, উদ্বেগ বা অনুরোধ থাকলে, দয়া করে আমাদের সাথে যোগাযোগ করুন:",
        email: "ইমেল: privacy@sudoku.vs",
        website: "ওয়েবসাইট: www.sudoku.vs",
        p2: "আমরা যত তাড়াতাড়ি সম্ভব আপনার জিজ্ঞাসার উত্তর দেব।"
      }
    },
    footer: {
      lastUpdated: "সর্বশেষ আপডেট: ১০ অক্টোবর ২০২৫",
      effectiveDate: "কার্যকর তারিখ: ১০ অক্টোবর ২০২৫"
    }
  },
  
languages: {
    en: "English",
    es: "Español", 
    fr: "Français",
    hi: "हिन्दी",
    bn: "বাংলা",
    pt: "Português",
    it: "Italiano",
    ru: "Русский",
    ja: "日本語",
    ko: "한국어"
},
  copywright: {
    text: 'কপিরাইট © 2025 সফটওয়্যার আর্কিটেক্টস লিমিটেড। সর্বস্বত্ব সংরক্ষিত।'
  }
};